import { Link, useSearchParams } from "react-router-dom";
import { Check } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("order") || "BO-XXXXXXXX";

  return (
    <div
      data-testid="checkout-success-page"
      className="bg-[#ffffff] min-h-screen flex items-center"
    >
      <div className="max-w-[800px] mx-auto px-6 md:px-10 py-24 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-[#ffffff] text-[#000000] rounded-full">
          <Check size={26} strokeWidth={2} />
        </div>
        <p className="overline mt-8">Order confirmed</p>
        <h1 className="font-serif text-5xl md:text-6xl mt-4 leading-tight">
          Thank you for joining the maison.
        </h1>
        <p className="mt-5 text-[#000000]/70 leading-relaxed">
          Your order <span className="text-[#000000] font-mono">{orderId}</span>{" "}
          is now with our atelier. You&apos;ll receive a tracking note when it ships.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link to="/account" className="btn-primary">
            View my orders
          </Link>
          <Link to="/shop" className="btn-secondary-dark">
            Continue browsing
          </Link>
        </div>
      </div>
    </div>
  );
}
